
export class ContainersList {
    ShipmentPackagesId : string;
    ActualPODDischarge : string | null;
    AvailablityDate : string | null;
    LastFreeDayDate : string | null;
    ActualEmptyReturn : string | null;
}